import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/fileTemplates'
import Component from 'components/FileTemplates'

export default createListViewContainer({ actions, selectors: selectors.fileTemplates })(Component)
